import GoogleMapsLoader from 'google-maps';

export default class ACFMap {
	static init(data = '', container = '') {
    return new ACFMap(data, container);
	}
	constructor(data, container) {
    this.mapMarkers = [];
    this.lat;
    this.lng;
    this.data = data;
    this.container = container;
    this.initMap();
  }
  
  setupListeners() {
    document.addEventListener('DOMContentLoaded', (event) => { this.initMap(); }, false);
  }
  
  
  initMap() {
    GoogleMapsLoader.KEY = 'AIzaSyCvFQwwPmC3y4o1TMJMLwi3YqG8TPDbL6U';
    GoogleMapsLoader.load((google) => { this.mapLoaded(google); });
  }


  fetchOffices(map, bounds) {
    let office = document.querySelectorAll('.office');
    //console.log(office);
    for(let i = 0; i < office.length; i++) {
      if( office[i].dataset.lat ) {
        this.addMarker(office[i].dataset.title, office[i].dataset.lat, office[i].dataset.lng, map, bounds);
        //console.log(office[i]);
      }
    }
    google.maps.event.addListenerOnce(map, 'bounds_changed', function() { this.setZoom(Math.min(7, this.getZoom())); });
    map.fitBounds(bounds);
    
  }


  
  addMarker(title, lat, lng, map, bounds) {
    //console.log(bounds);
    let latlng = new google.maps.LatLng( lat, lng );
    let marker = new google.maps.Marker({
      position	: latlng,
      map			  : map,
      title     : title
    });
    let infowindow = new google.maps.InfoWindow({
      content: title
    });
    bounds.extend(marker.position);
    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });

    
    this.mapMarkers.push(marker);
  }

  mapLoaded(google) {
    // console.log(this.data);
    this.google = google;
    let bounds = new google.maps.LatLngBounds();
    
    const mapWrapper = document.querySelector('.has-map');
    const options = {
      zoom: 2,
      zoomControl: true,
      mapTypeControl: false,
      fullscreenControl: false,
      scrollwheel: false,
          streetViewControl: false,
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.business",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#c9c9c9"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ]
        };
        

        let map = new google.maps.Map(mapWrapper, options);
        
        this.fetchOffices(map, bounds);
        // var listener = new google.maps.event.addListener(map, "idle", function() { 
        //   if (map.getZoom() > 14) map.setZoom(7); 
        //   new google.maps.event.removeListener(listener); 
        // });
        // console.log(this.mapMarkers);
        
    return map;
  }
}